import {
  Component,
  Input,
}                           from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DvlaLookupMotHistoryModel } from './typings/dvla-lookup.mot-history';
import { Table }                     from '../table/types/table';

@Component({
  template: require('./dvla-lookup.mot-history.row.expanded.component.html')
})
export class DvlaLookupMotHistoryExpandedRowComponent {
  public tableSettings : Table = {
    columns: [
      {
        field : 'item_type',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.CLASSIFICATION')
        }
      },
      {
        field : 'text',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.REASON')
        }
      }
    ],
    pagination: {
      enabled: false
    }
  };

  @Input() record: DvlaLookupMotHistoryModel;

  constructor (
    private translateService: TranslateService
  ) {}
}